import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import ReactDatepicker from "react-datepicker";
import styles from "components/reports/reports-form.scss";
import "components/common/datepicker.scss";
import { Field, reduxForm } from "redux-form";
import { categoryType, reduxFormInputType, selectOptionType, vendorType } from "custom-prop-types";
import { MultiSelect, SimpleSelect } from "components/common/select";
import { Button } from "components/common/button";
import { getThisFinancialYear, getLastFinancialYear } from "utils/financial-year";

const StatelessReportsForm = ({ categories, change, currency, onSubmitReport, vendors }) => (
  <div>
    <h1>Create a new report</h1>
    <form onSubmit={ (e) => { e.preventDefault(); onSubmitReport(); } }>
      { renderFields("Name (optional)", textInput, "name", "Enter a report name") }
      { renderDateRange(change, currency) }
      { renderFields("Category (optional)", multiSelectField, "categories", "Categories...", categories) }
      { renderFields("Vendor (optional)", multiSelectField, "vendors", "Vendors...", vendors) }
      { renderFields("Email (optional)", textInput, "email", "The report will be sent to this email address") }
      { renderFields("Report Type", selectField, "type", "Choose a report type", reportTypes) }

      <div className={ styles.actions }>
        <Button primary type="submit">Create Report</Button>
      </div>
    </form>
  </div>
);

export const ReportsForm = reduxForm({ form: "reports" })(StatelessReportsForm);

StatelessReportsForm.propTypes = {
  categories: PropTypes.arrayOf(categoryType).isRequired,
  change: PropTypes.func.isRequired,
  currency: PropTypes.string.isRequired,
  onSubmitReport: PropTypes.func.isRequired,
  vendors: PropTypes.arrayOf(vendorType).isRequired
};

const renderFields = (title, component, name, placeholder, options = null) => (
  <div className={ styles["fields-container"] }>
    <h4>{ title }</h4>
    <Field
      component={ component }
      name={ name }
      options={ options }
      placeholder={ placeholder }
    />
  </div>
);

const renderDateRange = (change, currency) => (
  <div className={ styles["fields-container"] }>
    <h4>Date Range</h4>
    <div className={ styles["fields-container__row"] }>
      <Field
        change={ change }
        component={ dateInput }
        currency={ currency }
        name="startDate"
        placeholder="Start Date"
      />
      <Field
        change={ change }
        component={ dateInput }
        currency={ currency }
        name="endDate"
        placeholder="End Date"
      />
    </div>
  </div>
);

const textInput = (props) => (
  <div className={ styles["fields-container__row"] }>
    <input { ...props.input } className={ styles.fields } placeholder={ props.placeholder } />
  </div>
);

textInput.propTypes = {
  input: reduxFormInputType.isRequired,
  placeholder: PropTypes.string.isRequired
};

const dateInput = ({ input: { name, onChange, onFocus, value }, change, currency, placeholder }) => {
  const otherField = name === "startDate" ? "endDate" : "startDate";
  return (
    <ReactDatepicker
      dateFormat="DD/MM/YYYY"
      name={ name }
      onChange={ onChange }
      onFocus={ onFocus }
      placeholderText={ placeholder }
      selected={ value ? moment(value) : null }
      value={ value }
    >
      <div className={ styles["financial-year"] }>
        <Button link onClick={ () => getFinancialYearRange(onChange, change, otherField, true, currency) }>
          Last financial year
        </Button>
        <Button link onClick={ () => getFinancialYearRange(onChange, change, otherField, false, currency) }>
          This financial year
        </Button>
      </div>
    </ReactDatepicker>
  );
};

dateInput.propTypes = textInput.propTypes;

const getFinancialYearRange = (onAddStartDate, onAddEndDate, otherField, isLast, currency) => {
  const { startDate, endDate } = isLast ? getLastFinancialYear(currency) : getThisFinancialYear(currency);
  onAddStartDate(startDate);
  onAddEndDate(otherField, endDate);
};

const multiSelectField = (props) => (
  <div className={ styles["fields-container__row"] }>
    <MultiSelect { ...props } options={ mapData(props.options) } placeholder={ props.placeholder } />
  </div>
);

multiSelectField.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([categoryType, vendorType])
  ).isRequired,
  placeholder: PropTypes.string.isRequired
};

const selectField = ({ input: { onChange, value }, options, placeholder }) => (
  <div className={ styles["fields-container__row"] }>
    <SimpleSelect
      data={ options }
      onChange={ onChange }
      placeholder={ placeholder }
      value={ value }
    />
  </div>
);

selectField.propTypes = {
  input: reduxFormInputType.isRequired,
  options: PropTypes.arrayOf(selectOptionType).isRequired,
  placeholder: PropTypes.string.isRequired
};

const mapData = (data) => data.map(d => (
  { key: d.name, name: d.name }
));

const reportTypes = [
  { key: "pdf", name: "PDF" },
  { key: "csv", name: "Excel / CSV" }
];



// WEBPACK FOOTER //
// ./src/js/components/reports/reports-form.jsx